import React from "react";
import IconLoading from "../Loader";

import * as sc from "./styles";

const BookButton = ({ title, disabled, isLoading, onClick }) => {
  return (
    <sc.BookButton onClick={onClick} disabled={disabled} isLoading={isLoading}>
      {isLoading ? <IconLoading /> : title}
    </sc.BookButton>
  );
};

export default BookButton;
